export class PointerUtil {
    private static readonly AVAILABLE_POINTERS = [
        'battery_connection',
        'battery_disconnect',
        'end_report',
        'jamming',
        'low_battery',
        'sos',
        'speeding',
        'start_report',
        'stop',
    ]

    private static readonly DEFAULT_POINTER = 'default_alert'

    static getPointerPath(alertType: string): string {
        const cleanType = alertType?.toLowerCase().trim()

        if (!cleanType) {
            return this.getDefaultPointerPath()
        }

        const pointerName = `pointer_${cleanType}`
        const exists = this.AVAILABLE_POINTERS.includes(cleanType)

        if (exists) {
            try {
                return require(`@/assets/img/pointers/${pointerName}.png`)
            } catch (error) {
                console.warn(`Pointer no encontrado: ${pointerName}, usando default`)
                return this.getDefaultPointerPath()
            }
        } else {
            console.warn(`Tipo de alerta no reconocido: ${cleanType}, usando pointer por defecto`)
            return this.getDefaultPointerPath()
        }
    }

    private static getDefaultPointerPath(): string {
        try {
            return require(`@/assets/img/pointers/pointer_${this.DEFAULT_POINTER}.png`)
        } catch (error) {
            console.error('Error al cargar pointer por defecto:', error)
            return require('@/assets/img/pointers/pointer_sos.png')
        }
    }

    static hasPointer(alertType: string): boolean {
        const cleanType = alertType?.toLowerCase().trim()
        return cleanType ? this.AVAILABLE_POINTERS.includes(cleanType) : false
    }

    static getAvailablePointers(): string[] {
        return [...this.AVAILABLE_POINTERS]
    }
}
